var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "4e7fd855108a1b4a132d4816a0191330.png",
    width: 279,
    height: 267
});